import { DQI_OPTIONS, DqiFilterOption } from "src/pages/DataHealthDashboard/constants"

export const getDqiLabel = (dqi: string): string => {
  const dqiOption = DQI_OPTIONS.find((option: DqiFilterOption) => option.value === dqi)
  return dqiOption?.label || "Overall"
}
